var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.58021 5.83366C4.30671 5.38647 4.16602 4.83604 4.16602 4.16699C4.16602 2.8479 5.15798 1.66699 6.66602 1.66699C8.17601 1.66699 9.39374 2.67835 9.99935 4.26185C10.605 2.67835 11.8227 1.66699 13.3327 1.66699C14.8407 1.66699 15.8327 2.8479 15.8327 4.16699C15.8327 4.83604 15.692 5.38647 15.4185 5.83366H16.666C17.5865 5.83366 18.3327 6.57985 18.3327 7.50033V9.16699C18.3327 10.0875 17.5865 10.8337 16.666 10.8337V16.667C16.666 17.5875 15.9198 18.3337 14.9993 18.3337H4.99935C4.07887 18.3337 3.33268 17.5875 3.33268 16.667V10.8337C2.41221 10.8337 1.66602 10.0875 1.66602 9.16699V7.50033C1.66602 6.57985 2.41221 5.83366 3.33268 5.83366H4.58021ZM9.16602 7.50033H3.33268V9.16699H9.16602V7.50033ZM10.8327 9.16699H16.666V7.50033H10.8327V9.16699ZM9.16602 16.667V10.8337H4.99935V16.667H9.16602ZM10.8327 16.667H14.9993V10.8337H10.8327V16.667ZM6.66602 3.33366C6.14906 3.33366 5.83268 3.71029 5.83268 4.16699C5.83268 5.21135 6.68018 5.70793 8.69053 5.8124C8.4671 4.25999 7.63449 3.33366 6.66602 3.33366ZM13.2739 3.33366C12.3054 3.33366 11.4728 4.25999 11.2493 5.8124C13.2597 5.70793 14.1072 5.21135 14.1072 4.16699C14.1072 3.71029 13.7908 3.33366 13.2739 3.33366Z",
    fill: "url(#paint0_linear_51889_99131)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_51889_99131",
    x1: 1.99927,
    y1: 2,
    x2: 15.4993,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7D62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC3489"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendGift);
export default __webpack_public_path__ + "static/media/send-gift.65e38fd2e697bb57e81e0a1825fccdc0.svg";
export { ForwardRef as ReactComponent };